<template>
  <div style="height: 400px">
    <GridVx
      ref="agGrid"
      dom-layout="scroll"
      :columns="columns"
      :rows="bookingDetailStore.sub_booking_group_services"
      row-selection="single"
      class="agGrid"
    />
  </div>
</template>

<script>
import { dateFormatter } from '@/utils/dataFormatter'
import { bookingDetailStore } from '../stores/'

export default {
  data() {
    return {
      columns: [
        {
          headerName: 'Mã',
          field: 'special_service_code',
          tooltipField: 'special_service_code',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          sortable: false
        },
        {
          headerName: 'Tên',
          field: 'first_name',
          tooltipField: 'first_name',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          sortable: false
        },
        {
          headerName: 'Giá đơn vị',
          field: 'price',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          cellRenderer: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          sortable: false
        },
        {
          headerName: 'Số lượng',
          field: 'quantity',
          tooltipField: 'quantity',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          sortable: false
        },
        {
          headerName: 'Từ ngày',
          field: 'service_start_date',
          tooltipValueGetter: params => {
            return params.value ? dateFormatter(params.value) : null
          },
          valueFormatter: params => {
            return params.value ? dateFormatter(params.value) : null
          },
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          sortable: false
        },
        {
          headerName: 'Đến ngày',
          field: 'service_end_date',
          tooltipValueGetter: params => {
            return params.value ? dateFormatter(params.value) : null
          },
          valueFormatter: params => {
            return params.value ? dateFormatter(params.value) : null
          },
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          sortable: false
        },
        {
          headerName: 'Nhân Viên',
          field: 'employee_name',
          tooltipField: 'employee_name',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          sortable: false
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          sortable: false
        }
      ],
      bookingDetailStore
    }
  }
}
</script>

<style></style>
